import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../../store/actions/index';

import TextChart from '../../../Charts/TextChart';
import {
  fechaFinPeriodoMesActualFunc,
  fechaFinPeriodoMesAnteriorFunc,
  fechaInicioPeriodoMesActualFunc,
  fechaInicioPeriodoMesAnteriorFunc
} from '../../../../shared/fechas';

const TextoCobranzasMensual = (props) => {
  useEffect(() => {
    if (!props.estaCargado && !props.empresa && !props.estaOculto && props.ejecucionDePagina) {
      props.onLoadChart();
    }
    if (props.empresa) {
      props.onLoadChart(props.empresa.id);
    }

    return () => {
      if (props.empresa) {
        props.onUnmountChart();
      }
    };
  }, [props.ejecucionDePagina]);
  const isDisabledChart = props.estaOculto && !props.empresa;

  return (
    <TextChart
      title={`Cobranzas del mes ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}  ${
        props.empresa ? `${props.empresa.nombre}` : ``
      }`}
      bigAmount={props.mesActual}
      bigAmountTooltip={`Período ${fechaInicioPeriodoMesActualFunc()} a ${fechaFinPeriodoMesActualFunc()} `}
      smallAmount={props.mesAnterior}
      smallAmountTooltip={`Período ${fechaInicioPeriodoMesAnteriorFunc()} a ${fechaFinPeriodoMesAnteriorFunc()}`}
      bigCurrency
      smallCurrency
      loading={props.loading}
      disabled={isDisabledChart}
      porcentaje
      border={props.border && !props.error}
      imgSinDatos={props.error}
      onFiltersClick={() => props.onShowFiltersModal()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.ventas.textoCobranzasMensual.loading,
    error: state.ventas.textoCobranzasMensual.error,
    mesActual: state.ventas.textoCobranzasMensual.mesActual,
    mesAnterior: state.ventas.textoCobranzasMensual.mesAnterior,
    estaCargado: state.ventas.textoCobranzasMensual.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.cobranzasDelMes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: (idEmpresa) => dispatch(actions.loadTextoCobranzasMensual(idEmpresa)),
    onUnmountChart: () => dispatch(actions.clearTextoCobranzaMensual()),
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Cobranzas del mes', ['cobranza']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoCobranzasMensual);
